import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

export const INITIAL_STATE = {
  scriptImported: false,
  currentAdType: 'home',
  pageNavigations: 0,
  ads: [],
}

export const SCRIPT_IMPORTED = 'i24-reader/taboola/SCRIPT_IMPORTED'
export const WEB_PUSH_INITIALIZED = 'i24-reader/taboola/WEB_PUSH_INITIALIZED'
export const PUSH_PAGE_NAVIGATION = 'i24-reader/taboola/PUSH_PAGE_NAVIGATION'
export const PAGE_NAVIGATION_PUSHED = 'i24-reader/taboola/PAGE_NAVIGATION_PUSHED'
export const PUSH_AD = 'i24-reader/taboola/PUSH_AD'
export const AD_PUSHED = 'i24-reader/taboola/AD_PUSHED'
export const REMOVE_AD = 'i24-reader/taboola/REMOVE_AD'

// scriptImported :: () -> Action SCRIPT_IMPORTED
export const scriptImported = always({ type: SCRIPT_IMPORTED })

// webPushInitialized :: () -> Action.WEB_PUSH_INITIALIZED
export const webPushInitialized = () => ({ type: WEB_PUSH_INITIALIZED })

// pushPageNavigation :: String -> Action PUSH_PAGE_NAVIGATION
export const pushPageNavigation = adType => ({
  type: PUSH_PAGE_NAVIGATION,
  adType,
})

// pageNavigationPushed :: String -> Action PAGE_NAVIGATION_PUSHED
export const pageNavigationPushed = adType => ({
  type: PAGE_NAVIGATION_PUSHED,
  adType,
})

// pushAd :: (String, String, String, String) -> Action PUSH_AD
export const pushAd = (name, placement, targetType, mode) => ({
  type: PUSH_AD,
  name,
  placement,
  targetType,
  mode,
})

// adPushed :: (String, String, String, String) -> Action AD_PUSHED
export const adPushed = (name, placement, targetType, mode) => ({
  type: AD_PUSHED,
  name,
  placement,
  targetType,
  mode,
})

// removeAd :: String -> Action REMOVE_AD
export const removeAd = name => ({
  type: REMOVE_AD,
  name,
})

// taboola :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [SCRIPT_IMPORTED]: state => ({
    ...state,
    scriptImported: true,
  }),

  [PUSH_PAGE_NAVIGATION]: (state, { adType }) => ({
    ...state,
    currentAdType: adType,
  }),

  [PAGE_NAVIGATION_PUSHED]: state => ({
    ...state,
    pageNavigations: state.pageNavigations + 1,
  }),

  [AD_PUSHED]: (state, { name, placement, targetType, mode }) => ({
    ...state,
    ads: state.ads.findIndex(ad => ad.name === name) === -1
      ? [...state.ads, { name, placement, targetType, mode }]
      : state.ads,
  }),

  [REMOVE_AD]: (state, { name }) => ({
    ...state,
    ads: state.ads.filter(ad => ad.name !== name),
  }),
})
